import { render } from "./DemoFinish.vue?vue&type=template&id=81ed4bbe"
import script from "./DemoFinish.vue?vue&type=script&lang=js"
export * from "./DemoFinish.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__